<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-toolbar flat dense color="primary" dark>
            <v-toolbar-title>{{ $tc('models.training', 2) }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon dark :loading="loading" @click="init">
              <v-icon>refresh</v-icon>
            </v-btn>
            <v-btn flat @click="openForm('create')">
              {{ $t('action.buttons.new') }}
            </v-btn>
          </v-toolbar>
          <v-toolbar card dense color="white">
            <training-filters v-model="localFilters" @search="search" />
            <v-text-field
              v-model="localFilters.match"
              flat
              hide-details
              :placeholder="$t('action.buttons.search')"
              prepend-icon="search"
              clearable
              solo
            />
          </v-toolbar>
          <v-divider />
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="formatedList"
              :rows-per-page-items="[10, 25, 50]"
              :loading="loading"
              disable-initial-sort
              :total-items="localPagination.totalItems"
              :pagination.sync="localPagination"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-center px-0">
                  <v-icon
                    color="primary"
                    class="mr-1"
                    @click="openView(props.item._id)"
                  >
                    visibility
                  </v-icon>
                  <v-icon
                    color="success"
                    class="mr-1"
                    @click="openForm('edit', props.item._id)"
                  >
                    edit
                  </v-icon>
                  <v-icon
                    color="error"
                    @click="ifDelete(props.item._id, props.item.relTrainingId)"
                  >
                    delete
                  </v-icon>
                </td>
                <!-- <td class="text-xs-center">{{props.item.status}}</td> -->

                <!-- <td>{{props.item.name}}</td> -->
                <td class="text-xs-center" style="min-width: 130px">
                  {{ props.item.date }}
                </td>
                <td class="text-xs-center" style="min-width: 110px">
                  {{ props.item.time }}
                  <span
                    v-if="
                      props.item.wtz && props.item.wtz != $store.state.offset
                    "
                    style="font-size: 11px"
                    >{{ ` (GMT ${props.item.wtz})` }}</span
                  >
                </td>
                <td>
                  <v-chip v-if="props.item.teamId" small color="transparent">
                    <v-avatar v-if="props.item.teamLogo" size="32">
                      <img :src="props.item.teamLogo" alt />
                    </v-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title class="body-1">
                        {{ props.item.teamId }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        v-if="props.item.teamCategory"
                        class="caption primary--text text--lighten-1 text-truncate"
                      >
                        {{ props.item.teamCategory.join(', ') }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-chip>
                </td>
                <td>
                  <v-chip v-if="props.item.location" small color="transparent">
                    <v-avatar v-if="props.item.location.photo" size="32">
                      <img :src="props.item.location.photo" alt />
                    </v-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>
                        {{ props.item.location.name }}
                      </v-list-tile-title>
                      <v-list-tile-sub-title
                        v-if="props.item.location.stadium"
                        class="caption primary--text text--lighten-1 text-truncate"
                      >
                        {{ props.item.location.stadium }}
                      </v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-chip>
                </td>
                <td class="text-xs-center">
                  <button-state :state="props.item.active" />
                </td>
                <td class="text-xs-center">
                  <button-state :state="props.item.started" />
                </td>
                <td class="text-xs-center">
                  <button-state :state="props.item.ended" />
                </td>
                <td class="text-xs-center" style="min-width: 180px">
                  {{ props.item.createdAt }}
                </td>
                <td style="min-width: 150px">
                  {{ props.item.createdBy }}
                </td>
                <td class="text-xs-center">
                  <i
                    class="icon material-icons cursor"
                    @click="openUpdated(props.item._id)"
                    >visibility</i
                  >
                </td>
              </template>
            </v-data-table>
          </v-card-text>
          <dialog-delete
            :dialog.sync="dialogDelete"
            :loading="loading"
            @delete="_setDelete"
          />
          <dialog-delete-weekly-trainings
            v-model="dialogDeleteWeekly"
            :loading="loading"
            @submit="_setDelete"
          />
          <dialog-updated-record
            :dialog.sync="dialogUpdated"
            :updated="updated"
          />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import TrainingFilters from './list/TrainingFilters'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import DialogDeleteWeeklyTrainings from '@/components/widgets/dialog/DialogDeleteWeeklyTrainings'
import DialogUpdatedRecord from '@/components/widgets/dialog/DialogUpdatedRecord'

export default {
  name: 'MatchList',
  components: {
    DialogDelete,
    DialogDeleteWeeklyTrainings,
    DialogUpdatedRecord,
    TrainingFilters,
  },
  props: {
    resetFilters: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      idDelete: '',
      dialogDelete: false,
      dialogDeleteWeekly: false,
      dialogUpdated: false,
      updated: [],
    }
  },
  watch: {
    dialogUpdated(val) {
      if (!val) this.reset()
    },
    'filters.match': {
      handler: function (/* val, oldVal */) {
        if (this.localPagination.page !== 1) this.localPagination.page = 1
        this.debounceFetch('trainings')
      },
    },
    'localPagination.page': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('trainings')
      },
    },
    'localPagination.rowsPerPage': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('trainings')
      },
    },
    'localPagination.sortBy': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('trainings')
      },
    },
    'localPagination.descending': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('trainings')
      },
    },
  },
  mounted() {
    // if (this.resetFilters) {
    // this.$store.dispatch('trainings/resetFilters')
    // }
    this.init()
  },
  computed: {
    ...mapState({
      loading: (state) => state.trainings.loading,
      selected: (state) => state.trainings.selected,
      pagination: (state) => state.trainings.pagination,
      filters: (state) => state.trainings.filters,
    }),
    ...mapGetters({
      formatedList: 'trainings/formatedList',
    }),
    headers() {
      return [
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },

        // {
        //   text: this.$t('titles.matches.status'),
        //   align: 'center',
        //   sortable: false
        // },
        // {
        //   text: this.$t('fields.global.name'),
        //   align: 'center',
        //   value: 'name'
        // },
        {
          text: this.$t('fields.global.date'),
          align: 'center',
          value: 'date',
        },
        {
          text: this.$t('fields.global.time'),
          align: 'center',
          value: 'time',
        },
        {
          text: this.$tc('models.team'),
          value: 'team',
          sortable: false,
        },

        {
          text: this.$t('fields.global.location'),
          value: 'location',
          sortable: false,
        },
        {
          text: this.$t('fields.global.state'),
          align: 'center',
          value: 'active',
          sortable: false,
        },
        {
          text: this.$t('titles.matches.started'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.matches.finalized'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.global.createdAt'),
          align: 'center',
          value: 'createdAt',
          sortable: false,
        },
        {
          text: this.$t('fields.global.createdBy'),
          value: 'createdBy',
          sortable: false,
        },
        {
          text: this.$t('titles.global.updates'),
          align: 'center',
          sortable: false,
        },
      ]
    },
    localFilters: {
      get() {
        return this.filters
      },
      set(value) {
        this.$store.commit('trainings/setFilters', value)
      },
    },
    localPagination: {
      get() {
        return this.pagination
      },
      set(value) {
        this.$store.commit('trainings/setPagination', value)
      },
    },
  },
  methods: {
    ...mapActions({
      fetchOne: 'trainings/fetchOne',
      getOne: 'trainings/getOne',
      setDelete: 'trainings/delete',
      reset: 'trainings/reset',
      fetchList: 'trainings/fetchList',
      fetchEvents: 'matchEvents/fetchList',
      fetchTypeEvents: 'typeEvents/fetchList',
    }),
    init() {
      this.fetchList()
    },
    search() {
      this.localPagination.page = 1
      this.init()
    },
    openView(id) {
      this.$router.push({ name: 'training-view', params: { id } })
    },
    openForm(action = 'create', id) {
      this.$router.push({ name: 'training-form', params: { id, action } })
    },
    openUpdated(id) {
      this.getOne(id).then((training) => {
        if (training && Array.isArray(training.updated)) {
          this.updated = training.updated.slice()
        } else {
          this.updated = []
        }
        this.dialogUpdated = true
      })
    },
    ifDelete(id, relTrainingId) {
      this.idDelete = id
      if (relTrainingId) {
        this.dialogDeleteWeekly = true
      } else {
        this.dialogDelete = true
      }
    },
    _setDelete(delType = 'current') {
      this.setDelete(`${this.idDelete}/${delType}`).finally(() => {
        this.dialogDelete = false
        this.dialogDeleteWeekly = false
      })
    },
  },
}
</script>
